module.exports = __webpack_public_path__ + "img/img5.e5ee7bed.svg";